import Link from "next/link";

export type CtaType = { text: string; href: string; className: string }
export function CtaButtonsComponent({ ctas }: { ctas: CtaType[], withScore?: boolean }) {
    return (

        <div className="cta-buttons_component">
            <div className="button-row is-centered-buttons">
                {ctas.map((cta, idx) => (
                    <Link key={idx} href={cta.href} className={cta.className}>
                        {cta.text}
                    </Link>
                ))}
            </div>
        </div>
    )
}